import {buildImageUrl} from './helper';

const stripUndefined = value => {
  if (Array.isArray(value)) {
    return value.map(stripUndefined).filter(item => item !== undefined);
  }
  if (value && typeof value === 'object') {
    return Object.entries(value).reduce((acc, [key, entry]) => {
      const cleaned = stripUndefined(entry);
      if (cleaned !== undefined && cleaned !== null && cleaned !== '') {
        acc[key] = cleaned;
      }
      return acc;
    }, {});
  }
  return value;
};

const toPlainText = text =>
  String(text || '')
    .replace(/!\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/[#*_`>~|-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 5000);

/**
 * Build schema.org Product JSON-LD for consumer product detail pages.
 */
const buildProductSchema = (product, pageUrl) => {
  if (!product?.name) return null;

  const imagePath = product.primaryImageUrl || (Array.isArray(product.imageUrls) ? product.imageUrls[0] : undefined);
  const image = imagePath ? buildImageUrl(imagePath, '600x600') : undefined;
  const rentalPrice = product.rentalPrice ?? product.originalRentalPrice;
  const description = toPlainText(product.description);

  return stripUndefined({
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    image: image ? [image] : undefined,
    description: description || undefined,
    sku: product.productCode || undefined,
    brand: product.brand?.name
      ? {
          '@type': 'Brand',
          name: product.brand.name,
        }
      : undefined,
    offers:
      product.isRentEnabled && rentalPrice != null
        ? {
            '@type': 'Offer',
            url: pageUrl,
            priceCurrency: 'VND',
            price: String(rentalPrice),
            availability: 'https://schema.org/InStock',
          }
        : undefined,
  });
};

export default buildProductSchema;
